var map = {
	"./decidim/gamification/badges/decidim_gamification_badges_accepted_proposals.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images/decidim/gamification/badges/decidim_gamification_badges_accepted_proposals.svg",
	"./decidim/gamification/badges/decidim_gamification_badges_proposal_votes.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images/decidim/gamification/badges/decidim_gamification_badges_proposal_votes.svg",
	"./decidim/gamification/badges/decidim_gamification_badges_proposals.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images/decidim/gamification/badges/decidim_gamification_badges_proposals.svg",
	"./decidim/proposals/decidim_proposals.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images/decidim/proposals/decidim_proposals.svg",
	"./decidim/proposals/proposal-placeholder-card-g.svg": "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images/decidim/proposals/proposal-placeholder-card-g.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/ruby/3.2.0/bundler/gems/decidim-c8535dac229b/decidim-proposals/app/packs/images sync recursive ^\\.\\/.*$";